module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }